import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LsqCommonModule } from '@lsq-frontend/common-ui';
import { LsqCoreModule } from '@lsq-frontend/common-ui';
import { LsqTablesModule } from '@lsq-frontend/common-ui';
import { NoDataBoxComponent } from './no-data-box/no-data-box.component';

@NgModule({
    imports: [
        CommonModule,
        LsqCoreModule.forChild(),
        LsqCommonModule.forChild(),
        LsqTablesModule.forRoot()
    ],
    declarations: [NoDataBoxComponent],
    exports: [NoDataBoxComponent]
})
export class SupplyChainDirectCommonModule {}
